import React, {useCallback, useContext, useMemo} from 'react';
import FormField, {Props} from '@src/components/Form/FormField';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {NestedListWidgetProps} from '@src/@types/components/Form';
import CommentsList from '../CommentsList';
import {FormTabsContext} from '@src/contexts/FormTabsContext';
import app from '@src/helpers/app';

const listWrapperStyles = {maxWidth: '700px'} as React.CSSProperties;

export function OrderCommentsList<Model extends IOrderModel>(
        props:
                Pick<NestedListWidgetProps<Model>, 'model' | 'formName' | 'forceDisabled'> &
                Pick<React.ComponentProps<typeof CommentsList>, 'prepareComments' | 'maxHeight'>
) {
    const queryKey = useMemo(() => {
        return app('queryKeys').getCustomQueryOfExactModelQueryKey(
                'Orders',
                props.model?.id,
                'comments-list'
        );
    }, [props.model?.id]);

    if (!props.formName || !props.model) {
        return null;
    }

    return <div style={listWrapperStyles}>
        <CommentsList
                label="OrdersShow.fields.order-comments"
                labelClassName="pt-0"
                queryCacheKey={queryKey}
                modelId={props.model?.id}
                controllerName={props.formName}
                isDisabled={props.forceDisabled}
                getCommentsRouteName="orders.comments.index"
                createCommentRouteName="orders.comments.store"
                prepareComments={props.prepareComments}
                intersectionObserverRoot={null}
                maxHeight={props.maxHeight}
        />
    </div>;
}

function ActualField<Model extends IOrderModel>(props: NestedListWidgetProps<Model>) {
    const {tabName} = props;
    const tabsContext = useContext(FormTabsContext);

    type OnCommentsReceivedType = Required<React.ComponentProps<typeof CommentsList>>['prepareComments'];
    const onCommentsReceived = useCallback<OnCommentsReceivedType>(comments => {
        if (tabName && tabsContext && tabsContext.isVisibleTab(tabName)) {
            tabsContext.setBadge(tabName, {
                label: String(comments?.length ?? 0),
            });
        }

        return comments;
    }, [tabName, tabsContext]);

    return <OrderCommentsList {...props} prepareComments={onCommentsReceived}/>;
}

export default function OrderCommentsField<Model extends IOrderModel = IOrderModel>(props: Props<Model>) {
    return <FormField
            {...props}
            withoutLayout={true}
            fieldElement={ActualField}
    />;
}
